import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  makeStyles,
  Badge,
  MenuItem,
  Avatar,
  Menu,
  Tooltip,
  IconButton,
  Box,
  useTheme,
  SwipeableDrawer,
  List,
  ListItem,
  ListItemText,
  Hidden,
  Chip,
  Switch,
} from "@material-ui/core";
import { Link, NavLink } from "react-router-dom";
import NotificationsIcon from "@material-ui/icons/Notifications";
import PersonIcon from "@material-ui/icons/Person";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Brightness4Icon from "@material-ui/icons/Brightness4"; // Moon icon for dark mode
import Brightness7Icon from "@material-ui/icons/Brightness7"; // Sun icon for light mode
import history from "../../utils/HistoryUtils";
import { apiClient } from "../../config/apiClient";
import Notify from "../Notify/Notify";
import { useDispatch, useSelector } from "react-redux";
import { switchAccount } from "../../store/action";
import { MyShiftAccessCheck } from "../../components/MyShiftAccessInfo/MyShiftAccessInfo";
import { notificationClear } from "../../../src/store/action/notificationMsg";
import ApiConfig from "../../../src/config/ApiConfig";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import logo from "../../../src/assets/images/logo.png";
import ScheduleIcon from "@material-ui/icons/Schedule";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import WorkIcon from "@material-ui/icons/Work";
import BusinessIcon from "@material-ui/icons/Business";
import * as actions from "../../store/action";
import { Person } from "@material-ui/icons";
import updatedLogo from "../../../src/assets/images/updatedLogo.svg";
const useStyles = makeStyles((theme) => ({
  appBar: {
    borderRadius: "0px !important",
    padding: "0px !important",
  },
  toolbar: {
    minHeight: 70,
    padding: "0 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(3),
    "& img": {
      width: "110px",
      height: "auto",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "scale(1.05)",
      },
    },
  },
  navContainer: {
    display: "flex",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  navLink: {
    color: theme.palette.text.primary,
    textDecoration: "none",
    margin: theme.spacing(0, 1.5),
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    transition: "all 0.2s ease",
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.action.hover,
    },
    "&.active": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light + "20",
      fontWeight: 600,
    },
    "& svg": {
      marginRight: theme.spacing(1),
      fontSize: "1.2rem",
    },
  },
  userProfile: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 1.5),
    borderRadius: theme.spacing(2),
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  avatar: {
    width: 36,
    height: 36,
    marginRight: theme.spacing(1.5),
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    marginRight: theme.spacing(1),
    "& .MuiTypography-caption": {
      color: theme.palette.text.secondary,
      maxWidth: "120px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  actionButton: {
    minWidth: "auto",
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderRadius: "50%",
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  notificationBadge: {
    "& .MuiBadge-badge": {
      right: -3,
      top: 5,
      backgroundColor: theme.palette.error.main,
      color: theme.palette.common.white,
      fontWeight: 600,
    },
  },
  menuBox: {
    "& .MuiPaper-root": {
      borderRadius: theme.spacing(1.5),
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
      marginTop: theme.spacing(1),
      minWidth: 280,
    },
  },
  menuItem: {
    padding: theme.spacing(1.5, 2),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  mobileMenuButton: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "flex",
    },
  },
  drawer: {
    "& .MuiDrawer-paper": {
      width: 280,
      padding: theme.spacing(2),
      borderRadius: "0px !important",
      padding: "0px !important",
    },
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 0, 2, 0),
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  mobileNavLink: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1.5, 2),
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    textDecoration: "none",
    transition: "all 0.2s ease",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.primary.main,
    },
    "&.active": {
      backgroundColor: theme.palette.primary.light + "20",
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
    "& svg": {
      marginRight: theme.spacing(2),
    },
  },
  organizationChip: {
    backgroundColor: theme.palette.primary.light + "20",
    color: theme.palette.primary.main,
    fontWeight: 500,
    marginLeft: theme.spacing(2),
    height: 28,
    "& .MuiChip-label": {
      padding: theme.spacing(0, 1.5),
    },
  },
}));

const Navbar = ({ onThemeChange, currentTheme = 'light' }) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  const signeeInfo = JSON.parse(window.localStorage.getItem("signeeInfo"));
  const baseUrl = ApiConfig.API_URL + "uploads/signee_profile_pic/";
  const [msg, setMsg] = useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [switchTrust, setSwitchTrust] = React.useState(null);
  const open = Boolean(anchorEl);
  const open2 = Boolean(switchTrust);
  const [emailAccount, setEmailAccount] = useState();
  const getProfilerName = JSON.parse(window.localStorage.getItem("signeeInfo"));
  const getToken = JSON.parse(window.localStorage.getItem("token"));
  const { swtichAccSuccess } = useSelector((state) => state.switchAccount);
  const { notificationList } = useSelector((state) => state.notification);
  const notificationInfo = useSelector((state) => state.notificationMsg);
  const [data, setData] = useState({
    email: getProfilerName.email,
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleClickNotification = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickAccount = (event) => {
    setSwitchTrust(event.currentTarget);
  };

  useEffect(() => {
    dispatch(actions.getNotification(1));
  }, [dispatch]);

  const handleClose = () => {
    setAnchorEl(null);
    setSwitchTrust(null);
  };

  const getEmailAccount = async () => {
    await apiClient(true)
      .post(`api/signee/get-email-organisation`, data)
      .then((response) => {
        const dataItem = response.data;
        setEmailAccount(dataItem);
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  useEffect(() => {
    getEmailAccount();
  }, []);

  const logout = () => {
    apiClient(true)
      .get(`api/signee/logout`)
      .then((response) => {
        if (response) {
          setMsg(response.data.message);
          localStorage.clear();
          setTimeout(() => {
            history.push("/login");
            window.location.reload();
          }, 2000);
        }
      })
      .catch((error) => {
        console.log("error.message", error.message);
        localStorage.clear();
        setTimeout(() => {
          history.push("/login");
        }, 2000);
      });
  };

  const handleSwitchAccount = (id) => {
    if (getProfilerName.parent_id !== id) {
      dispatch(switchAccount(id, getProfilerName?.id));
    }
  };

  const unReadNotification =
    notificationList?.data &&
    notificationList?.data.filter((val) => val.is_read === 0).length;

  const readNotification = (e, val) => {
    e.preventDefault();
    const requestData = {
      notification_id: val.id,
      is_read: true,
      signee_id: val.signee_id,
    };
    dispatch(actions.readNotification(requestData));
  };

  const clearNotificationMsg = () => {
    let reqParam = { message: null, status: null, type: null };
    setTimeout(() => {
      dispatch(notificationClear(reqParam));
    }, 4000);
  };

  const ReadAllNotification = () => {
    const requestData = {
      notification_id: "All",
      is_read: true,
    };
    dispatch(actions.readNotification(requestData));
  };

  const handleThemeToggle = () => {
    const newTheme = currentTheme === 'light' ? 'dark' : 'light';
    if (onThemeChange) {
      onThemeChange(newTheme);
    }
  };

  const drawer = (
    <div>
      <div className={classes.drawerHeader}>
        <Link to="/shifts" className={classes.logo}>
          <img src={logo} alt="Pluto logo" />
        </Link>
        <IconButton onClick={handleDrawerToggle}>
          <CloseIcon />
        </IconButton>
      </div>

      <Box className={classes.userProfile} mb={2}>
        <Avatar
          className={classes.avatar}
          src={
            signeeInfo?.profile_pic ? baseUrl + signeeInfo.profile_pic : null
          }
        >
          {!signeeInfo?.profile_pic && <PersonIcon />}
        </Avatar>
        <Box className={classes.userInfo}>
          <Typography variant="subtitle2">
            {getProfilerName?.first_name || "User"}
          </Typography>
          <Typography variant="caption">
            {getProfilerName?.organization_name || "Organization"}
          </Typography>
        </Box>
      </Box>

      {/* Theme Toggle in Mobile Drawer */}
      <Box display="flex" alignItems="center" justifyContent="space-between" p={2} mb={1}>
        <Box display="flex" alignItems="center">
          <Brightness4Icon className={classes.themeIcon} />
          <Typography variant="body2" style={{ marginLeft: 8 }}>
            Dark Mode
          </Typography>
        </Box>
        <Switch
          checked={currentTheme === 'dark'}
          onChange={handleThemeToggle}
          color="primary"
        />
      </Box>

      <List>
        <ListItem
          button
          component={NavLink}
          to="/shifts"
          className={classes.mobileNavLink}
          onClick={handleDrawerToggle}
        >
          <ScheduleIcon />
          <ListItemText primary="Browse Shifts" />
        </ListItem>

        {MyShiftAccessCheck() && (
          <ListItem
            button
            component={NavLink}
            to="/my-shifts/upcoming"
            className={classes.mobileNavLink}
            onClick={handleDrawerToggle}
          >
            <WorkIcon />
            <ListItemText primary="My Shifts" />
          </ListItem>
        )}

        <ListItem
          button
          component={NavLink}
          to="/profile/documents"
          className={classes.mobileNavLink}
          onClick={handleDrawerToggle}
        >
          <VerifiedUserIcon />
          <ListItemText primary="Compliance" />
        </ListItem>

        <ListItem
          button
          component={NavLink}
          to="/notification"
          className={classes.mobileNavLink}
          onClick={handleDrawerToggle}
        >
          <NotificationsIcon />
          <ListItemText primary="Notifications" />
          {unReadNotification > 0 && (
            <Chip
              size="small"
              label={unReadNotification}
              color="secondary"
              style={{ marginLeft: "auto" }}
            />
          )}
        </ListItem>

        <ListItem button onClick={logout} className={classes.mobileNavLink}>
          <ExitToAppIcon />
          <ListItemText primary="Sign Out" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      {msg && msg !== "" && <Notify data={msg} status="success" />}

      {swtichAccSuccess && swtichAccSuccess?.message && (
        <Notify data={swtichAccSuccess?.message} status="success" />
      )}

      {notificationInfo?.message && (
        <>
          <Notify
            data={notificationInfo?.message}
            status={notificationInfo?.status ? "success" : "error"}
          />
          {clearNotificationMsg()}
        </>
      )}

      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Box display="flex" alignItems="center">
            {/* Logo */}
            <Link to="/shifts" className={classes.logo}>
              <img src={updatedLogo} alt="Pluto logo" />
            </Link>

            {/* Desktop Navigation */}
            <Box className={classes.navContainer}>
              <NavLink to="/shifts" className={classes.navLink}>
                <ScheduleIcon /> Browse Shifts
              </NavLink>

              {MyShiftAccessCheck() && (
                <NavLink to="/my-shifts/upcoming" className={classes.navLink}>
                  <WorkIcon /> My Shifts
                </NavLink>
              )}

              <NavLink to="/profile/documents" className={classes.navLink}>
                <VerifiedUserIcon /> Compliance
              </NavLink>

              <NavLink to="/profile/information" className={classes.navLink}>
                <Person /> Profile
              </NavLink>
            </Box>
          </Box>

          {/* Right Section: Actions */}
          <Box display="flex" alignItems="center">
            {/* Theme Toggle Switch */}
            <Hidden smDown>
              <Tooltip title={`Switch to ${currentTheme === 'light' ? 'dark' : 'light'} mode`}>
                <IconButton
                  onClick={handleThemeToggle}
                  aria-label="toggle theme"
                >
                  {currentTheme === 'light' ? (
                    <Brightness4Icon className={classes.themeIcon} />
                  ) : (
                    <Brightness7Icon className={classes.themeIcon} />
                  )}
                </IconButton>
              </Tooltip>
            </Hidden>

            {/* Notifications */}
            <Tooltip title="Notifications">
              <IconButton
                className={classes.actionButton}
                onClick={handleClickNotification}
                aria-label="show notifications"
              >
                <Badge
                  badgeContent={unReadNotification}
                  color="error"
                  className={classes.notificationBadge}
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            </Tooltip>

            {/* Notifications Dropdown */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.menuBox}
            >
              <MenuItem disabled style={{ opacity: 1, cursor: "default", borderBottom: `1px solid ${theme.palette.divider}` }}>
                <Typography variant="subtitle1" color="primary">
                  Notifications
                </Typography>
              </MenuItem>

              {notificationList?.data?.length > 0 ? ([
                ...notificationList?.data.slice(0, 5).map((val, index) => (
                  <MenuItem
                    onClick={(e) => readNotification(e, val)}
                    className={classes.menuItem}
                    style={{ background: val.is_read === 0 ? theme.palette.info.light + "40" : "transparent", }}
                    key={index}
                  >
                    <Box>
                      <Typography variant="body2" style={{ fontWeight: val.is_read === 0 ? 600 : 400 }}>
                        {val.message}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {new Date(val.created_at).toLocaleString()}
                      </Typography>
                    </Box>
                  </MenuItem>
                )),
                <MenuItem key="actions" disableRipple disableGutters style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${theme.palette.divider}` }}>
                  <Button size="small" component={Link} to="/notification" onClick={handleClose} >
                    View all
                  </Button>
                  <Button size="small" color="primary" onClick={ReadAllNotification}>
                    Mark all as read
                  </Button>
                </MenuItem>
              ]
              ) : (
                <MenuItem className={classes.menuItem}>
                  <Typography variant="body2" color="textSecondary">
                    No notifications found
                  </Typography>
                </MenuItem>
              )}
            </Menu>

            {/* User Profile Dropdown */}
            <Hidden smDown>
              <Box className={classes.userProfile} onClick={handleClickAccount}>
                <Avatar
                  className={classes.avatar}
                  src={signeeInfo?.profile_pic ? baseUrl + signeeInfo.profile_pic : null}
                >
                  {!signeeInfo?.profile_pic && <PersonIcon />}
                </Avatar>
                <Box className={classes.userInfo}>
                  <Typography variant="subtitle2">
                    {getProfilerName?.first_name || "User"}
                  </Typography>
                  <Typography variant="caption">
                    {getProfilerName?.organization_name || "Organization"}
                  </Typography>
                </Box>
              </Box>
            </Hidden>

            <Menu
              anchorEl={switchTrust}
              open={open2}
              onClose={handleClose}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              className={classes.menuBox}
            >
              <Box>
                <Box button onClick={logout} className={classes.mobileNavLink}>
                  <ExitToAppIcon />
                  <ListItemText primary="Sign Out" />
                </Box>
              </Box>

              <Box p={1} pl={2} pr={2} borderBottom={`1px solid ${theme.palette.divider}`}>
                <Typography variant="subtitle1" color="primary">
                  Switch Organization
                </Typography>
              </Box>

              {emailAccount?.data &&
                emailAccount?.data.map((list, index) => {
                  const isActive =
                    getProfilerName.organization_name ===
                    list.organization_name;
                  return (
                    <MenuItem
                      key={index}
                      onClick={() => handleSwitchAccount(list.organization_id)}
                      className={classes.menuItem}
                      selected={isActive}
                      disabled={isActive}
                    >
                      <BusinessIcon
                        style={{
                          marginRight: theme.spacing(1.5),
                          opacity: 0.7,
                        }}
                      />
                      <Typography variant="body1">
                        {list.organization_name}
                      </Typography>
                      {isActive && (
                        <Chip
                          label="Current"
                          size="small"
                          color="primary"
                          style={{ marginLeft: "auto" }}
                        />
                      )}
                    </MenuItem>
                  );
                })}
            </Menu>

            <Hidden lgUp>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.mobileMenuButton}
              >
                <MenuIcon />
              </IconButton>
            </Hidden>
          </Box>
        </Toolbar>
      </AppBar>

      <Hidden lgUp>
        <SwipeableDrawer
          variant="temporary"
          anchor="right"
          open={mobileOpen}
          onOpen={handleDrawerToggle}
          onClose={handleDrawerToggle}
          className={classes.drawer}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {drawer}
        </SwipeableDrawer>
      </Hidden>
    </>
  );
};

export default Navbar;